import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { SettingsHeaderComponent } from './settings-header.component';

@NgModule({
    declarations: [SettingsHeaderComponent],
    imports: [CommonModule, MatIconModule, MatButtonModule, TranslateModule],
    exports: [SettingsHeaderComponent],
})
export class SettingsHeaderModule {}
